import { PROP } from "@/utils/constants"
import { PriceOutput } from "@renec-foundation/relend-adapter"
import { atom } from "jotai"

export const COC = "COC"
export const FIKA = "FIKA"
export const LTC = "LTC"
export const RND = "RND"
export const SPORT = "SPORT"
export const TRX = "TRX"

export type PriceKey =
  | "BNB"
  | "BTC"
  | "COC"
  | "ETH"
  | "FIKA"
  | "GAST"
  | "LTC"
  | "NGN"
  | "PLUS1"
  | "PROP"
  | "RENEC"
  | "REUSD"
  | "RND"
  | "SPORT"
  | "TRX"
  | "VND"
  | "REL"
  | "RELEND"

export type PriceAtom = {
  [key in PriceKey]?: number
}

export const DEFAULT_STE_SYMBOL = PROP

// TODO: update error handling to show "Price not found" instead of NaN
export const NULL_PRICE = NaN

// default data at 2024-03-27T03:10:24.387Z
export const renecPriceDataAtom = atom<PriceAtom>({
  BNB: 584.2553294192585,
  BTC: 70607.97558707737,
  COC: 12,
  ETH: 3618.248117240056,
  FIKA: 23,
  GAST: 0.771447216,
  LTC: 96.94326585595563,
  NGN: 7.662036961432241e-4,
  PLUS1: 0.222745611,
  PROP: 0.021888171,
  RENEC: 0.30591969,
  REUSD: 0.99444796,
  RND: 0.009310931,
  SPORT: 46,
  TRX: 0.12126510456629498,
  VND: 3.8807588284828725e-5,
  REL: NULL_PRICE, // fake value
  RELEND: NULL_PRICE, // fake value
})

// TODO: remove when REL is listed
export const INITIAL_REL_PRICE = 0.0029389999999999998

export const solanaTokenOraclePricesAtom = atom<PriceOutput | null>(null)
